import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "homelab-container" }
const _hoisted_2 = { class: "homelab-header" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "intro-text" }
const _hoisted_5 = { class: "topology-section ln-glass-elevated" }
const _hoisted_6 = { class: "section-header" }
const _hoisted_7 = { class: "topology-caption" }
const _hoisted_8 = { class: "layers-overview" }
const _hoisted_9 = { class: "layers-grid" }
const _hoisted_10 = { class: "competencies-section" }
const _hoisted_11 = { class: "section-header" }
const _hoisted_12 = { class: "competencies-grid" }
const _hoisted_13 = { class: "context-section ln-glass-elevated" }
const _hoisted_14 = { class: "section-header" }
const _hoisted_15 = { class: "context-content" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayerNavigator = _resolveComponent("LayerNavigator")!
  const _component_HomeLabImage = _resolveComponent("HomeLabImage")!
  const _component_InfraLayerCard = _resolveComponent("InfraLayerCard")!
  const _component_InfraCompetencyCard = _resolveComponent("InfraCompetencyCard")!
  const _component_InfraLayerFooter = _resolveComponent("InfraLayerFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LayerNavigator, { "is-preview": _ctx.isPreview }, null, 8, ["is-preview"]),
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "osi-badge" }, "Infrastructure Overview", -1)),
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('infra.title')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('infra.subtitle')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('infra.intro')), 1)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mdi mdi-sitemap-outline" }, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('homelab.architectureTitle')), 1)
      ]),
      _createVNode(_component_HomeLabImage),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('homelab.caption')), 1)
    ]),
    _createElementVNode("section", _hoisted_8, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-header" }, [
        _createElementVNode("span", { class: "mdi mdi-layers-triple-outline" }),
        _createElementVNode("h2", null, "Architecture en Couches")
      ], -1)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_InfraLayerCard, {
          layerNumber: _ctx.$t('infra.layers.l0.name'),
          title: _ctx.$t('infra.layers.l0.title'),
          description: _ctx.$t('infra.layers.l0.proof'),
          badge: "OSI 1-2",
          icon: "mdi-server-network",
          variant: "ln-glass-teal",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToLayer('infra-l0')))
        }, null, 8, ["layerNumber", "title", "description"]),
        _createVNode(_component_InfraLayerCard, {
          layerNumber: _ctx.$t('infra.layers.l1.name'),
          title: _ctx.$t('infra.layers.l1.title'),
          description: "Orchestration GitOps & Réseau Dual-Homed.",
          badge: "OSI 3-4",
          icon: "mdi-kubernetes",
          variant: "ln-glass-terracotta",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLayer('infra-l1')))
        }, null, 8, ["layerNumber", "title"]),
        _createVNode(_component_InfraLayerCard, {
          layerNumber: _ctx.$t('infra.layers.l2.name'),
          title: _ctx.$t('infra.layers.l2.title'),
          description: "Persistence (Longhorn) & DBaaS via Operators.",
          badge: "OSI 5-6",
          icon: "mdi-database",
          variant: "ln-glass-stone",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToLayer('infra-l2')))
        }, null, 8, ["layerNumber", "title"]),
        _createVNode(_component_InfraLayerCard, {
          layerNumber: _ctx.$t('infra.layers.l3.name'),
          title: _ctx.$t('infra.layers.l3.title'),
          description: "Vault, Zitadel & Alerting Physique 'Nuke'.",
          badge: "OSI 7",
          icon: "mdi-shield-lock",
          variant: "ln-glass-elevated",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToLayer('infra-l3')))
        }, null, 8, ["layerNumber", "title"])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mdi mdi-shield-check-outline" }, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('homelab.learningsTitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-server",
          title: _ctx.$t('homelab.competencies.sysadmin.title'),
          description: _ctx.$t('homelab.competencies.sysadmin.desc')
        }, null, 8, ["title", "description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-kubernetes",
          title: _ctx.$t('homelab.competencies.k8s.title'),
          description: _ctx.$t('homelab.competencies.k8s.desc')
        }, null, 8, ["title", "description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-infinity",
          title: _ctx.$t('homelab.competencies.devops.title'),
          description: _ctx.$t('homelab.competencies.devops.desc')
        }, null, 8, ["title", "description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-database-sync",
          title: _ctx.$t('homelab.competencies.storage.title'),
          description: _ctx.$t('homelab.competencies.storage.desc')
        }, null, 8, ["title", "description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-chart-bell-curve-cumulative",
          title: _ctx.$t('homelab.competencies.obs.title'),
          description: _ctx.$t('homelab.competencies.obs.desc')
        }, null, 8, ["title", "description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-lock-outline",
          title: _ctx.$t('homelab.competencies.secops.title'),
          description: _ctx.$t('homelab.competencies.secops.desc')
        }, null, 8, ["title", "description"])
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mdi mdi-briefcase-outline" }, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('homelab.contextTitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", {
          innerHTML: _ctx.$t('homelab.context1')
        }, null, 8, _hoisted_16),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('homelab.context2')
        }, null, 8, _hoisted_17)
      ])
    ]),
    _createVNode(_component_InfraLayerFooter, {
      nextRoute: "infra-l0",
      nextLabel: 'Commencer l\'exploration : ' + _ctx.$t('infra.layers.l0.name'),
      onNavigate: _ctx.goToLayer
    }, null, 8, ["nextLabel", "onNavigate"])
  ]))
}